import { useNavigate } from "react-router-dom"

import { ScheduleDTO } from "../../../../models/ScheduleDTO"

/*
	"Abrir Portal" (Portal de Clase, 2026-10-17): desde Asistencias el maestro salta al portal de su horario
	(Mis Clases, sección classPortal). Solo se ofrece al maestro del horario, que siempre tiene esa sección.
*/
const BotonPortalClase = ({horario, className} : {horario : ScheduleDTO, className? : string}) =>
{
	const navigate = useNavigate()

	return <button type="button" className={className || "waAccionFila"} onClick={(e) => { e.stopPropagation(); navigate("/classPortal?h=" + horario.scheduleId) }}>
		Abrir Portal
	</button>
}

export default BotonPortalClase
